<template>
  <button @click="nextPage" :class="{active}">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    to: String,
    back: Boolean,
    active: Boolean
  },
  methods: {
    nextPage() {
      if (this.back) {
        this.$router.back();
        this.$emit("back", '');
        return
      }
      if (this.to) {
        this.$router.push(this.to);
        this.$emit("back", '');
      }
    }
  }
};
</script>
